import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { 
  Card, CardBody, Col, Container, Row, 
  Nav, NavItem, NavLink, TabContent, TabPane, 
  Table, Spinner, Badge, Button 
} from "reactstrap";
import classnames from "classnames";

// Breadcrumb (Yolu kendi projene göre ayarla)
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const KullaniciAktiviteleri = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  document.title = `Kullanıcı 360 Görünümü (#${id}) | HarmanaGEL Admin`;

  const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

  // --- STATE'LER ---
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("docs"); // İlk açılışta belgeler sekmesi gelsin
  
  const [userData, setUserData] = useState(null);
  const [adverts, setAdverts] = useState([]);
  const [offers, setOffers] = useState([]);
  const [ratings, setRatings] = useState([]);

  // Finansal İstatistikler
  const [totalSpent, setTotalSpent] = useState(0);
  const [totalEarned, setTotalEarned] = useState(0);
  const [avgScore, setAvgScore] = useState(0);

  // --- VERİLERİ ÇEKME ---
  useEffect(() => {
    const fetchUserActivities = async () => {
      setIsLoading(true);
      try {
        const token = localStorage.getItem("token") || JSON.parse(localStorage.getItem("authUser") || "{}")?.Token;
        const fetchOpts = { headers: { 'Content-Type': 'application/json', ...(token ? { 'Authorization': `Bearer ${token}` } : {}) } };

        // 1. Kullanıcı Bilgisi
        const userRes = fetch(`${BASE_URL}/KULLANICILAR?$filter=ID eq ${id}&$select=ID,AD_SOYAD,HESAP_TURU,Mail_Adress,CEP_NONumber,AKTIF_DURUM,OLUSTURMA_TARIHI`, fetchOpts);

        // 2. Açtığı İlanlar (silinenler hariç)
        const advertsRes = fetch(`${BASE_URL}/ILANLAR?$filter=KIMDEN_ID eq ${id} and AKTIF_DURUM ne 'Silindi'&$orderby=ID desc`, fetchOpts);

        // 3. Verdiği Teklifler
        const offersRes = fetch(`${BASE_URL}/ILAN_TEKLIFLERI?$filter=KULLANICI_ID eq ${id}&$expand=ILANLAR&$orderby=ID desc`, fetchOpts);

        // 4. Satıcıya Verilen Yorumlar (Puan)
        const ratingsRes = fetch(`${BASE_URL}/YORUMLAR?$filter=SATICI_ID eq ${id}&$expand=KULLANICILAR&$orderby=YORUM_TARIHI desc`, fetchOpts);

        // Hepsini paralel çekiyoruz
        const [uRes, aRes, oRes, rRes] = await Promise.all([userRes, advertsRes, offersRes, ratingsRes]);

        const uData = await uRes.json();
        const aData = await aRes.json();
        const oData = await oRes.json();
        const rData = await rRes.json();

        if (uData.value && uData.value.length > 0) setUserData(uData.value[0]);
        
        const fetchedAdverts = (aData.value || []).filter(
          adv => (adv.AKTIF_DURUM || "").toLowerCase() !== "silindi"
        );
        const fetchedOffers = oData.value || [];
        const fetchedRatings = rData.value || [];

        setAdverts(fetchedAdverts);
        setOffers(fetchedOffers);
        setRatings(fetchedRatings);

        // --- İSTATİSTİK HESAPLAMALARI ---
        const spent = fetchedAdverts.reduce((sum, adv) => sum + (adv.FIYAT || 0), 0);
        setTotalSpent(spent);

        const earned = fetchedOffers
          .filter(off => off.DURUM === 1)
          .reduce((sum, off) => sum + (off.TEKLIF_TUTARI || 0), 0);
        setTotalEarned(earned);

        if (fetchedRatings.length > 0) {
          const scoreSum = fetchedRatings.reduce((sum, r) => sum + (r.PUAN || 0), 0);
          setAvgScore(scoreSum / fetchedRatings.length);
        } else {
          setAvgScore(0);
        }

      } catch (error) {
        console.error("Kullanıcı aktiviteleri çekilemedi:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (id) fetchUserActivities();
  }, [id]);

  // --- YARDIMCI FONKSİYONLAR ---
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleString("tr-TR", {
      day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit"
    });
  };

  const renderStars = (score) => {
    return [...Array(5)].map((_, i) => (
      <i key={i} className={`mdi mdi-star ${i < score ? 'text-warning' : 'text-light'} fs-6 me-1`}></i>
    ));
  };

  const durumText = d => d === 1 ? "Kabul Edildi" : d === 2 ? "Reddedildi" : "Bekliyor";
  const durumColor = d => d === 1 ? "success" : d === 2 ? "danger" : "warning";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Kullanıcı 360 Görünümü" />

          <div className="mb-3">
            <Button color="light" className="fw-bold shadow-sm" onClick={() => navigate(-1)}>
              <i className="mdi mdi-arrow-left me-1"></i> Listeye Dön
            </Button>
          </div>

          {isLoading ? (
            <div className="text-center py-5">
              <Spinner color="primary" />
              <p className="mt-3 text-muted fw-medium">Tüm kayıtlar, belgeler ve finansal veriler yükleniyor...</p>
            </div>
          ) : !userData ? (
            <Card className="text-center py-5 shadow-sm border-0 rounded-4">
              <CardBody>
                <i className="mdi mdi-account-search-outline display-1 text-muted"></i>
                <h4 className="mt-3 fw-bold">Kullanıcı Bulunamadı</h4>
                <p className="text-muted">Sistemde bu ID'ye ait bir veri yok.</p>
              </CardBody>
            </Card>
          ) : (
            <Row>
              {/* SOL TARAF: KULLANICI ÖZETİ VE FİNANSAL VERİLER */}
              <Col xl={4}>
                <Card className="shadow-sm border-0 rounded-4 overflow-hidden mb-4">
                  <div className="bg-primary bg-soft p-4 text-center">
                    <div className="avatar-xl mx-auto mb-3">
                      <span className="avatar-title rounded-circle bg-primary text-white display-4 shadow">
                        {userData.AD_SOYAD?.charAt(0) || "U"}
                      </span>
                    </div>
                    <h4 className="fw-bold mb-1">{userData.AD_SOYAD}</h4>
                    <Badge color="info" className="font-size-13 px-3 py-1 mt-2 rounded-pill">
                      {userData.HESAP_TURU || "Bilinmeyen Rol"}
                    </Badge>
                  </div>
                  
                  <CardBody className="p-4">
                    <h6 className="text-muted fw-bold text-uppercase border-bottom pb-2 mb-3 font-size-12">İletişim & Durum</h6>
                    <div className="table-responsive mb-4">
                      <Table className="table-borderless table-sm mb-0">
                        <tbody>
                          <tr>
                            <th scope="row" className="px-0 fw-medium text-muted"><i className="mdi mdi-email-outline me-2 text-primary"></i>E-posta:</th>
                            <td className="text-end fw-bold text-dark">{userData.Mail_Adress}</td>
                          </tr>
                          <tr>
                            <th scope="row" className="px-0 fw-medium text-muted"><i className="mdi mdi-phone-outline me-2 text-primary"></i>Telefon:</th>
                            <td className="text-end fw-bold text-dark">{userData.CEP_NONumber || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row" className="px-0 fw-medium text-muted"><i className="mdi mdi-calendar-clock me-2 text-primary"></i>Üyelik Tarihi:</th>
                            <td className="text-end fw-medium text-muted">{formatDate(userData.OLUSTURMA_TARIHI)}</td>
                          </tr>
                          <tr>
                            <th scope="row" className="px-0 fw-medium text-muted"><i className="mdi mdi-check-decagram text-success me-2 fs-5 align-middle"></i>Durum:</th>
                            <td className="text-end">
                              <Badge color={userData.AKTIF_DURUM === 'aktif' ? "success" : "danger"} className="font-size-12 px-2">
                                {userData.AKTIF_DURUM === 'aktif' ? "Aktif" : "Pasif"}
                              </Badge>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                    
                    <h6 className="text-muted fw-bold text-uppercase border-bottom pb-2 mb-3 font-size-12">Finansal Özet & Kalite</h6>
                    <Row className="text-center g-2 mb-3">
                      <Col xs={6}>
                        <div className="p-3 bg-light rounded-3 border">
                          <h5 className="fw-bold text-danger mb-1">{totalSpent.toLocaleString("tr-TR")} ₺</h5>
                          <p className="text-muted font-size-11 mb-0 fw-bold text-uppercase">Toplam Harcama</p>
                        </div>
                      </Col>
                      <Col xs={6}>
                        <div className="p-3 bg-light rounded-3 border">
                          <h5 className="fw-bold text-success mb-1">{totalEarned.toLocaleString("tr-TR")} ₺</h5>
                          <p className="text-muted font-size-11 mb-0 fw-bold text-uppercase">Tahmini Kazanç</p>
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className="p-3 bg-soft-warning rounded-3 border border-warning d-flex justify-content-between align-items-center">
                          <div>
                            <p className="text-warning font-size-12 mb-0 fw-bold text-uppercase">Kalite Puanı</p>
                            <h4 className="fw-bold text-warning mb-0">{avgScore.toFixed(1)} / 5.0</h4>
                          </div>
                          <div>{renderStars(Math.round(avgScore))}</div>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>

              {/* SAĞ TARAF: DETAY SEKMELERİ */}
              <Col xl={8}>
                <Card className="shadow-sm border-0 rounded-4 mb-4">
                  <div className="p-3 bg-light rounded-top-4 border-bottom overflow-auto" style={{ whiteSpace: "nowrap" }}>
                    <Nav tabs className="nav-tabs-custom border-0 flex-nowrap">
                      <NavItem>
                        <NavLink className={classnames("fw-bold font-size-14 cursor-pointer border-0 bg-transparent", { active: activeTab === "docs" })} onClick={() => setActiveTab("docs")}>
                          <i className="mdi mdi-card-account-details-outline me-1"></i> Kimlik & Belgeler
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink className={classnames("fw-bold font-size-14 cursor-pointer border-0 bg-transparent", { active: activeTab === "finance" })} onClick={() => setActiveTab("finance")}>
                          <i className="mdi mdi-bank me-1"></i> Finans & Şirket
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink className={classnames("fw-bold font-size-14 cursor-pointer border-0 bg-transparent", { active: activeTab === "adverts" })} onClick={() => setActiveTab("adverts")}>
                          <i className="mdi mdi-bullhorn-outline me-1"></i> İlanlar ({adverts.length})
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink className={classnames("fw-bold font-size-14 cursor-pointer border-0 bg-transparent", { active: activeTab === "offers" })} onClick={() => setActiveTab("offers")}>
                          <i className="mdi mdi-hand-coin-outline me-1"></i> Teklifler ({offers.length})
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink className={classnames("fw-bold font-size-14 cursor-pointer border-0 bg-transparent", { active: activeTab === "ratings" })} onClick={() => setActiveTab("ratings")}>
                          <i className="mdi mdi-star-circle-outline me-1 text-warning"></i> Değerlendirmeler ({ratings.length})
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </div>

                  <CardBody className="p-4">
                    <TabContent activeTab={activeTab}>

                      {/* --- YENİ SEKME: KİMLİK, ADRES VE BELGELER --- */}
                      <TabPane tabId="docs">
                        <Row>
                          <Col md={6}>
                            <h6 className="text-primary fw-bold border-bottom pb-2 mb-3"><i className="mdi mdi-map-marker-radius me-2"></i>Adres Bilgileri</h6>
                            <p className="mb-1"><strong>Şehir/İlçe:</strong> {address.Users_Address_City || "-"} / {address.Users_Address_Dist || "-"}</p>
                            <p className="mb-1"><strong>Açık Adres:</strong> {address.Users_Address_AdressText || "Kayıtlı adres bulunmuyor."}</p>
                          </Col>
                          <Col md={6}>
                            <h6 className="text-primary fw-bold border-bottom pb-2 mb-3"><i className="mdi mdi-card-bulleted-outline me-2"></i>Ehliyet Bilgileri</h6>
                            <p className="mb-1"><strong>Sınıf:</strong> {license.Driving_License_Class || "Belirtilmemiş"}</p>
                            <p className="mb-1"><strong>Belge No:</strong> {license.Driving_License_Number || "Belirtilmemiş"}</p>
                          </Col>
                        </Row>

                        <h6 className="text-primary fw-bold border-bottom pb-2 mb-3 mt-4"><i className="mdi mdi-file-document-multiple-outline me-2"></i>Resmi Evraklar (Yüklenen Belgeler)</h6>
                        <Row className="g-3">
                          {[
                            { name: "Kimlik Fotoğrafı", url: docs.Identity_Url },
                            { name: "Ehliyet Fotoğrafı", url: docs.License_Url },
                            { name: "Adli Sicil Kaydı", url: docs.Criminalrecord_Url },
                            { name: "Vergi Levhası", url: docs.Taxplate_Url },
                            { name: "Çekici Sertifikası", url: docs.TowingCertificate }
                          ].map((docItem, idx) => (
                            <Col md={4} sm={6} key={idx}>
                              <Card className="text-center border shadow-none bg-light h-100">
                                <CardBody className="p-3">
                                  <i className={`mdi ${docItem.url ? 'mdi-file-check-outline text-success' : 'mdi-file-remove-outline text-muted'} display-4 mb-2 d-block`}></i>
                                  <h6 className="fw-bold font-size-13">{docItem.name}</h6>
                                  {docItem.url ? (
                                    <a href={docItem.url} target="_blank" rel="noreferrer" className="btn btn-sm btn-primary w-100 mt-2">
                                      <i className="mdi mdi-eye me-1"></i>Görüntüle
                                    </a>
                                  ) : (
                                    <Badge color="secondary" className="w-100 mt-2 py-1">Yüklenmemiş</Badge>
                                  )}
                                </CardBody>
                              </Card>
                            </Col>
                          ))}
                        </Row>
                      </TabPane>

                      {/* --- YENİ SEKME: FİNANS VE ŞİRKET --- */}
                      <TabPane tabId="finance">
                        <Row>
                          <Col md={6}>
                            <h6 className="text-primary fw-bold border-bottom pb-2 mb-3"><i className="mdi mdi-domain me-2"></i>Şirket Bilgileri</h6>
                            <p className="mb-1"><strong>Firma Adı:</strong> {company.Users_Company_Name || "Şahıs / Bireysel Kullanıcı"}</p>
                            <p className="mb-1"><strong>Şirket Türü:</strong> {invoice.Company_Type || "-"}</p>
                            <p className="mb-1"><strong>Vergi No:</strong> {invoice.KdvNumber || "-"}</p>
                            <p className="mb-1"><strong>Vergi Dairesi:</strong> {invoice.VergiDairesi || "-"}</p>
                            <p className="mb-1"><strong>Fatura Adresi:</strong> {invoice.Adres || "-"}</p>
                          </Col>
                          <Col md={6}>
                            <h6 className="text-primary fw-bold border-bottom pb-2 mb-3"><i className="mdi mdi-bank me-2"></i>Banka Bilgileri</h6>
                            <p className="mb-1"><strong>Banka Adı:</strong> {bank.Users_BankAccount_BankName || "Kayıtlı Banka Yok"}</p>
                            <p className="mb-1"><strong>Hesap Sahibi:</strong> {bank.Users_BankAccount_HolderName || "-"}</p>
                            <p className="mb-1 text-primary fw-bold"><strong>IBAN:</strong> {bank.Users_BankAccount_Iban || "-"}</p>
                            
                            <h6 className="text-primary fw-bold border-bottom pb-2 mb-3 mt-4"><i className="mdi mdi-information-outline me-2"></i>Fatura Ayarları</h6>
                            <p className="mb-1"><strong>KDV'ye Tabi:</strong> {invoice.Subject_To_VAT ? <Badge color="success">Evet</Badge> : <Badge color="danger">Hayır</Badge>}</p>
                            <p className="mb-1"><strong>Faturalandırma Yetkisi:</strong> {invoice.Invoicing_Mandate ? <Badge color="success">Evet</Badge> : <Badge color="danger">Hayır</Badge>}</p>
                          </Col>
                        </Row>
                      </TabPane>

                      {/* --- SEKME 3: KULLANICININ AÇTIĞI İLANLAR --- */}
                      <TabPane tabId="adverts">
                        {adverts.length === 0 ? (
                           <div className="text-center py-5 text-muted">
                             <i className="mdi mdi-clipboard-text-off-outline display-4 mb-3 d-block"></i>
                             <p className="fs-5">Kullanıcı henüz bir ilan oluşturmamış.</p>
                           </div>
                        ) : (
                          <div className="table-responsive">
                            <Table className="table-hover table-nowrap align-middle mb-0">
                              <thead className="table-light">
                                <tr>
                                  <th>İlan Kimliği</th>
                                  <th>Güzergah (Başlangıç - Bitiş)</th>
                                  <th>Bütçe</th>
                                  <th>Durum / Admin Onayı</th>
                                  <th className="text-end">İşlem</th>
                                </tr>
                              </thead>
                              <tbody>
                                {adverts.map((adv) => {
                                  const loc = adv.ADRESLER?.[0];
                                  return (
                                    <tr key={adv.ID}>
                                      <td>
                                        <span className="fw-bold">#{adv.ID}</span><br />
                                        <span className="font-size-11 text-muted">{formatDate(adv.OLUSTURMA_TARIHI)}</span>
                                      </td>
                                      <td>
                                        <div className="text-truncate" style={{maxWidth: "200px"}}>
                                          <span className="text-success fw-medium"><i className="mdi mdi-ray-start-arrow me-1"></i>{loc?.ADRESLER_StartAddress?.split(',')[0] || "-"}</span><br/>
                                          <span className="text-danger fw-medium"><i className="mdi mdi-map-marker me-1"></i>{loc?.ADRESLER_FinishAddress?.split(',')[0] || "-"}</span>
                                        </div>
                                      </td>
                                      <td>
                                        <div className="fw-bold text-primary fs-6">{adv.Price?.toLocaleString("tr-TR")} ₺</div>
                                        <div className="font-size-12 text-muted">{adv.Advert_KM || loc?.Km || "-"} km</div>
                                      </td>
                                      <td>
                                        <Badge color={adv.Is_Active ? "success" : "secondary"} className="me-1 mb-1 d-block w-100">
                                          {adv.Is_Active ? "Yayında" : "Kapalı"}
                                        </Badge>
                                        <Badge color={adv.Is_AdminCheck ? "info" : "warning"} className="d-block w-100">
                                          {adv.Is_AdminCheck ? "Admin Onaylı" : "Onay Bekliyor"}
                                        </Badge>
                                      </td>
                                      <td className="text-end">
                                        <Link to={`/job-details/${adv.ID}`} className="btn btn-sm btn-light border fw-bold text-primary px-3">
                                          Detay
                                        </Link>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </Table>
                          </div>
                        )}
                      </TabPane>

                      {/* --- SEKME 4: KULLANICININ VERDİĞİ TEKLİFLER --- */}
                      <TabPane tabId="offers">
                        {offers.length === 0 ? (
                           <div className="text-center py-5 text-muted">
                             <i className="mdi mdi-handshake-outline display-4 mb-3 d-block"></i>
                             <p className="fs-5">Kullanıcı henüz bir teklif vermemiş.</p>
                           </div>
                        ) : (
                          <div className="table-responsive">
                            <Table className="table-hover table-nowrap align-middle mb-0">
                              <thead className="table-light">
                                <tr>
                                  <th>Teklif No</th>
                                  <th>Maliyet Dağılımı</th>
                                  <th>Teslimat Zamanı</th>
                                  <th>Teklif Durumu</th>
                                  <th className="text-end">İlan Detayı</th>
                                </tr>
                              </thead>
                              <tbody>
                                {offers.map((off) => {
                                  let statusColor = "warning";
                                  if (off.Offer_Status === "Kabul Edildi") statusColor = "success";
                                  if (off.Offer_Status === "Reddedildi") statusColor = "danger";

                                  return (
                                    <tr key={off.ID}>
                                      <td>
                                        <span className="fw-bold">#{off.ID}</span><br/>
                                        <Link to={`/job-details/${off.Advert_ID}`} className="font-size-11 text-muted text-decoration-underline">İlan #{off.Advert_ID}</Link>
                                      </td>
                                      <td>
                                        <div className="fw-bold text-dark mb-1">Toplam: {off.Price?.toLocaleString("tr-TR")} ₺</div>
                                        <div className="font-size-11 text-muted">Hizmet Bedeli: {off.Own_Offer} ₺</div>
                                        <div className="font-size-11 text-muted">Yol Masrafı: {off.Travel_Expenses || 0} ₺</div>
                                      </td>
                                      <td>
                                        <div className="fw-medium">{off.Delivery_Date ? new Date(off.Delivery_Date).toLocaleDateString('tr-TR') : "-"}</div>
                                        <div className="font-size-11 text-muted">Saat: {off.Start_Time?.slice(0,5)} - {off.End_Time?.slice(0,5)}</div>
                                      </td>
                                      <td>
                                        <Badge color={statusColor} className="px-2 py-1 font-size-12 mb-1 d-block text-center">
                                          {off.Offer_Status || "Bekliyor"}
                                        </Badge>
                                        {off.Offer_Status === "Reddedildi" && off.ReasonForRejection && (
                                          <div className="text-danger font-size-11 bg-soft-danger px-1 rounded text-center text-truncate" style={{maxWidth: "120px"}} title={off.ReasonForRejection}>
                                            {off.ReasonForRejection}
                                          </div>
                                        )}
                                      </td>
                                      <td className="text-end">
                                        <Link to={`/job-details/${off.Advert_ID}`} className="btn btn-sm btn-light border fw-bold text-primary px-3">
                                          Git
                                        </Link>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </Table>
                          </div>
                        )}
                      </TabPane>

                      {/* --- SEKME 5: DEĞERLENDİRMELER (KALİTE GEÇMİŞİ) --- */}
                      <TabPane tabId="ratings">
                        {ratings.length === 0 ? (
                           <div className="text-center py-5 text-muted">
                             <i className="mdi mdi-star-off-outline display-4 mb-3 d-block"></i>
                             <p className="fs-5">Bu kullanıcıya henüz bir değerlendirme yapılmamış.</p>
                           </div>
                        ) : (
                          <div className="d-flex flex-column gap-3">
                            {ratings.map((rating) => (
                              <div key={rating.ID} className="p-3 border rounded-3 bg-light bg-opacity-50">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <div className="d-flex align-items-center">
                                    <div className="avatar-xs me-2">
                                      <span className="avatar-title rounded-circle bg-primary-subtle text-primary">
                                        {rating.Users?.AD_SOYAD?.charAt(0) || "U"}
                                      </span>
                                    </div>
                                    <div>
                                      <h6 className="mb-0 fw-bold">{rating.Users?.AD_SOYAD || "İsimsiz Kullanıcı"}</h6>
                                      <small className="text-muted">{formatDate(rating.OLUSTURMA_TARIHI)} | İlan #{rating.Advert_ID}</small>
                                    </div>
                                  </div>
                                  <Badge color="warning" className="fs-6 px-2 py-1"><i className="mdi mdi-star me-1"></i>{rating.Score}</Badge>
                                </div>
                                <p className="mb-0 text-dark fw-medium mt-2 p-2 bg-white rounded border border-light" style={{lineHeight: "1.5"}}>
                                  {rating.Comment || <span className="text-muted fst-italic">Yorum bırakılmadı.</span>}
                                </p>
                              </div>
                            ))}
                          </div>
                        )}
                      </TabPane>

                    </TabContent>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

        </Container>
      </div>
    </React.Fragment>
  );
};

export default KullaniciAktiviteleri;